<script setup lang="ts">
import { TransitionRoot, TransitionChild, Dialog, DialogPanel } from '@headlessui/vue'

defineProps({
  modalStore: {
    type: Object,
    required: true,
  },
})
</script>

<template>
  <TransitionRoot appear :show="modalStore.state.active" as="template">
    <Dialog as="div" @close="modalStore.close" class="relative z-10">
      <TransitionChild
        as="template"
        enter="duration-300 ease-out"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="duration-200 ease-in"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 top-1 bg-white bg-opacity-25 bg-gradient-to-tr from-[#52B7B9]/0 via-[#52B7B9]/10 to-[#5D8DB4]/70 backdrop-blur"
        ></div>
      </TransitionChild>

      <div class="fixed inset-0 overflow-y-auto">
        <div class="flex min-h-full items-start justify-center pb-64 pt-1 text-center">
          <TransitionChild
            as="template"
            enter="transition ease duration-500 transform"
            enterFrom="opacity-0 -translate-y-12"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease duration-300 transform"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 -translate-y-12"
          >
            <DialogPanel
              class="w-full max-w-md transform cursor-default overflow-hidden rounded-b-md bg-white py-6 text-left align-middle shadow-xl ring-1 ring-black ring-opacity-5 transition-all"
            >
              <div class="px-6 text-gray-700">
                <slot name="main"></slot>
              </div>
              <div class="mt-6 border-t border-gray-100 px-6 pt-6">
                <slot name="footer"></slot>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>
